import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import PerksUsersTable from '../../../PerksHub/PerksUsersTable';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchPerksUsers } from './companyPerksApi';

/**
 * Company Perks → Employees/Members list.
 * Every user of the current population appears (people on nothing show dashes
 * and sort last); a row opens their perks profile.
 */
const CPerksUsers = () => {
  const navigate = useNavigate();
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  const fetcher = useCallback(
    (params) => fetchPerksUsers({ ...params, department }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Perks — {isB2BFansMode ? 'Members' : 'Employees'} | Shoorah</title>
      </Helmet>

      <p className="text-sm text-gray-500 dark:text-gray-400 mb-3">
        Your {isB2BFansMode ? 'members' : 'employees'} and which perks they are on. Open a user to
        see their full perks profile.
      </p>

      <PerksUsersTable
        fetcher={fetcher}
        showCompanyColumn={false}
        onOpenUser={(rowData) => navigate(`/${slug}/perks/user?userId=${rowData?._id}`)}
        tableName="company_perks_users"
      />
    </div>
  );
};

export default CPerksUsers;
